import { configureStore } from "@reduxjs/toolkit";
import operatorReducer from "./reducers/OperatorSlice";
import ticketReducer from "./reducers/TicketSlice";
import messagesReducer from "./reducers/MessageSlice";
import adminReducer from "./reducers/AdminSlice";
import userReducer from "./reducers/UserSlice";
import identificationReducer from "./reducers/IdentificationSlice";
import { use } from "react";
import applicationReducer from "./reducers/ApplicationSlice";
import devTicketReducer from "./reducers/Dev-TicketsSlice";

 
const store = configureStore({
  reducer: {
    operator: operatorReducer,
    tickets: ticketReducer,
    messages: messagesReducer,
    admin: adminReducer,
    users: userReducer,
    identification: identificationReducer,
    application: applicationReducer,
    devTicket: devTicketReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
